import { z } from "zod";

export const IEntryExitDashboardFilterSchema = z.object({
  fromDate: z.coerce.string().nullable().optional(),
  toDate: z.coerce.string().nullable().optional(),
  memberTypeID: z.string().nullish(),
  instituteID: z.string().nullish(),
  departmentID: z.string().nullish(),
  programID: z.string().nullish(),
});

export type IEntryExitDashboardFilter = z.infer<
  typeof IEntryExitDashboardFilterSchema
>;

export interface IEntryExitDashboardSummary {
  totalVisits: number;
  totalExits: number;
  currentlyInLibrary: number;
  avgDurationMinutes: number;
  todayVisits: number;
  todayCurrentlyInLibrary: number;
}

export interface IEntryExitTrendItem {
  timeLabel: string;
  entryCount: number;
  exitCount: number;
}

export interface IMemberTypeDistributionItem {
  memberTypeName: string;
  visitCount: number;
}

export interface IDepartmentDistributionItem {
  departmentName: string;
  instituteName: string;
  visitCount: number;
}

export interface IEntryExitDashboardCharts {
  trend: IEntryExitTrendItem[];
  memberTypeDistribution: IMemberTypeDistributionItem[];
  departmentDistribution: IDepartmentDistributionItem[];
}

export interface ICurrentlyInsideItem {
  entryExitID: string | number;
  memberID: string | number;
  memberCode: string;
  memberName: string;
  biometricCode?: string;
  memberTypeName: string;
  instituteName: string;
  departmentName: string;
  programName: string;
  entryTime: string;
  minutesInside: number;
  location?: string;
  visitPurpose?: string;
  remarks?: string;
}

export interface ICurrentlyInsideGridFilter {
  memberTypeID?: string | number | null;
  instituteID?: string | number | null;
  departmentID?: string | number | null;
  programID?: string | number | null;
  searchText?: string;
}

export interface IEntryExitDashboardLogItem {
  entryExitID: string | number;
  memberID: string | number;
  memberCode: string;
  memberName: string;
  biometricCode?: string;
  memberTypeName: string;
  instituteName: string;
  departmentName: string;
  programName: string;
  entryTime: string;
  exitTime?: string;
  durationMinutes: number;
  status: string;
  location?: string;
  visitPurpose?: string;
  remarks?: string;
}

export interface IEntryExitDashboardLogGridFilter {
  fromDate?: string | null;
  toDate?: string | null;
  memberTypeID?: string | number | null;
  instituteID?: string | number | null;
  departmentID?: string | number | null;
  programID?: string | number | null;
  statusFilter: number;
  searchText?: string;
}

export interface IDropdownOption {
  id?: string | number;
  name?: string;
  memberTypeID?: string | number;
  memberTypeName?: string;
  instituteID?: string | number;
  instituteName?: string;
  departmentID?: string | number;
  departmentName?: string;
  programID?: string | number;
  programName?: string;
}
